import { assert_instanceof, assert_not_equal, assert_not_null } from '@shared/asserts/utils_asserts';
import { FIELD__base } from '../../../_fields/_base/FIELD__base';

export function FN_FIELD__get_by_longest_path_match(target: any, path: string) {
  const dotCount = path.split('.').length - 1;

  if (dotCount != 1 && dotCount != 2) debugger;

  /*
   *
   */

  let parts = path.split('.');
  let out = target;

  // Try progressively longer suffixes (omitting left parts, keeping at least one, and always keeping the last)
  for (let i = 0; i < parts.length; i++) {
    const sub_path_parts = parts.slice(i);

    let current = target;

    let found = true;

    for (const part of sub_path_parts) {
      if (current != null && typeof current === 'object' && part in current) {
        current = current[part];
      } else {
        found = false;
        break;
      }
    }

    if (found) {
      out = current;
      break;
    }
  }

  assert_not_equal(out, target);
  assert_not_null(out);
  assert_instanceof(out, FIELD__base);

  return out;
}
